exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".admin-dashboard[data-v-028e8d42]{padding:24px;text-align:left}.welcome[data-v-028e8d42]{color:#555}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-028e8d42","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/admin/views/Dashboard.vue
// module id = 138
// module chunks = 0